import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lastn',
  standalone: false
})
export class LastnPipe implements PipeTransform {

  transform(array: object[], n: number): unknown {
    // Is loading if array is not defined
    if (!array || n < 1) {
      return [];
    }
    return array.slice(0, n);
  }

}
